export const deleteAuthToken = () => {
  sessionStorage.removeItem("authInfo");
};
